import { Component, OnInit,ViewChildren,QueryList, ViewChild} from '@angular/core';
import { MatPaginator, MatTableDataSource , MatSort } from '@angular/material';
import { APIEntityService } from '../../_services/entity/API-entity';
import { APILoginService } from '../../_services/login/API-login';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { style } from '@angular/animations';
import { MyDialogComponent } from '../../../../_helpers/Modals/my-dialog/my-dialog.component';
import { EntityDialogComponent } from '../../../../_helpers/Modals/entity-dialog/entity-dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as CryptoJS from 'crypto-js';
import { saveAs as importedSaveAs } from "file-saver";




const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today,'HH:mm','en-US','+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
console.log("formatTime -- : ",formatTime); 
//console.log("datecur :",  currentdat);
export interface DialogData {
setValue :string,
setRole : string
}
@Component({
  selector: 'app-entity-summary',
  templateUrl: './entity-summary.component.html',
  styleUrls: ['./entity-summary.component.css']
})
export class EntitySummaryComponent implements OnInit {

  deactvResult: any;
  fileDownload: any = [];

  newEntities: number[] = [];
  newSummaries: number[] = [];
  entity: any = [];
  entitySummary: any = [];
  entityRefNo: any;
  modelTest: any;
  entityId: any;
  filterData:any;
  public panCard:any = {};
  //entityRole: any;
  show: boolean = false;
  entityformshow: boolean =false;
  entitysummaryformshow: boolean =false;
  entityrejectionformshow: boolean =false;
  statusMongo:String;
  dataSource: MatTableDataSource<any>; 
  dataSource1: MatTableDataSource<any>;
  dataSource2: MatTableDataSource<any>;
  noRecord: any;
  noRecord1: any;
  noRecord2: any;
  	refNos= "";
  emailids= "";
  Entity_EmailID:any;
  EntityClass: any;

     
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>(); 
  @ViewChild('t1Sort') t1Sort: MatSort;
  @ViewChild('t2Sort') t2Sort: MatSort;
  @ViewChild('t3Sort') t3Sort: MatSort;
  
  
  dataSubject = new BehaviorSubject<any[]>([]);
  //displayedColumns: string[] = ['Entity_Ref_No','ApprovedAt', 'Entity_ID', 'Entity_Role', 'Entity_Name','Entity_EmailID', 'Entity_Addr', 'Documents','Entity_Status','Deactivate'];
   displayedColumns: string[] = ['Entity_Ref_No','ApprovedAt', 'Entity_ID', 'Entity_Role', 'Entity_Name','Entity_EmailID', 'Entity_Addr', 'Documents','Entity_Status'];
 // displayedColumns1: string[] = ['Reference No.', 'Entity Type', 'Entity Role', 'Name', 'Address', 'Documents','Download', 'Approve', 'Reject'];
 displayedColumns1: any[] = [
  'Entity_Ref_No','createdAt', 'Entity_Class','E_Org_Type', 'Entity_Role', 'Entity_Name','Entity_EmailID', 'Entity_Addr',
  'Pan',
     'Documents','Download',
    { def: 'Approve', showMobile: false },
    { def: 'Reject', showMobile: false },
  ];
  displayedColumns2: string[] = ['Entity_Ref_No','RejectedAt', 'Entity_Role', 'Entity_Name','Entity_EmailID', 'Entity_Addr','Entity_Status'];
  entityRole = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ROLE);
  deactivate=[];
 // Entity_Role_Approved: any;
 
  
   get
   (): string[] {
    
     const isMobile = this.entityRole != 'Application Adminstrator';
     let a = this.displayedColumns1
      .filter(cd => !isMobile || cd['showMobile'] !== false)
       .map(cd => typeof cd === 'string' ? cd : cd.def);
 
       return a;
   }
  
   // getDisplayedColumns(): string[] {
  //  console.log("this displayed coloumns method called");
 // const isMobile = this.entityRole === 'Network Adminstrator' || 'Operations User';
   //const isMobile = this.entityRole == 'Application Adminstrator';
  //  let a = this.displayedColumns1
   //   .filter(cd => !isMobile || cd['showMobile'] !== false)
    //  .map(cd => typeof cd ===  'string' ? cd : cd.def);

    //  return a;
 // }


  form1: any = {};
  form2: any = {};

  constructor(
    private es: APIEntityService,
    private ls: APILoginService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    public dialog: MatDialog,
    private $: $BroadcastManagerService) {}

  ngOnInit() {
   
 
    this.APIgetEntitySummary();
    this.APIgetAllEntitySummaries();
	this.APIgetEntityRejection();
    console.log("entity role is",this.entityRole)
    this.modelTest = this.$modal;
    this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    this.Entity_EmailID = this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID);
	this.EntityClass = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_CLASS);
	console.log("this.EntityClass ---- ",this.EntityClass);
  //console.log("Entity_EmailIDEntity_EmailIDEntity_EmailID",this.Entity_EmailID)
  //console.log("Entity_EmailIDEntity_EmailIDEntity_EmailID",this.entityId)

   // this.Entity_Role_Approved = this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID);
  }

  reset(){
   
    this.APIgetEntitySummary();
    console.log("first reset function");

  }

  reset1()
  {
    this.APIgetAllEntitySummaries();
    console.log("second reset function");
  }
   
   reset2()
  {
    this.APIgetEntityRejection();
    console.log("thired reset function");
  }
  

  
   decrypt(){
	   
	    const encryptedValues = ['e0912c26238f29604f5998fa1fbc78f6', '0888e0558c3bce328cd7cda17e045769'];
		
		const key = '18bcd0b950de300fb873788958fde988fec9b478a936a3061575b16f79977d5b';
		const IV = '2e11075e7b38fa20e192bc7089ccf32b';

		//for(let encrypted of encryptedValues) {
		const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Hex.parse('e0912c26238f29604f5998fa1fbc78f6') }, CryptoJS.enc.Hex.parse(key), { 
        iv: CryptoJS.enc.Hex.parse(IV), 
        mode: CryptoJS.mode.CBC
      });
     
   // console.log('Ciphertext:', encrypted);
   // console.log('Plain text:', decrypted.toString(CryptoJS.enc.Utf8));
   // }
   }
  
  entityDialog(refNo,emailid): void {
	this.refNos= refNo;
	this.emailids= emailid;
	const dialogRef = this.dialog.open(EntityDialogComponent, {
		data: {}  
	  });
	  
	  dialogRef.afterClosed().subscribe((res) => {
		  
		  //console.log(comment,"****");
		  
		  if(res.action == 'submit'){
			  this.rejectEntityComplaints(this.refNos,this.emailids,res.data)
		  }
		  
		 
		  
    // this.deactvResult = result;
   // console.log("on submit the root header in dialog",result)
    // if (result !== "undefined" && getValue === 'blacklist') {
     
      // this.deactivateEntity(result,emailid,role);
    // }
    // else if(result !== "undefined" && getValue === 'updaterole')
    // {
     // // this.updateRole(result,emailid)
    // }
   // console.log('The dialog was closed', result); 
  });
  
	  
  }
  

  onSubmitFilter(filterForm) {
    console.log(filterForm);
    const fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    const ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    const param = filterForm.search;

    console.log("fdate",fdate);
    console.log("ldate",ldate,"param",param);
    this.getAllEntityForApprovalFilter(filterForm.search,fdate,ldate);
    // Here we have call the funtion to retrieve data and change datasource
  }

  onSubmitFilter1(filterForm1) {
    console.log(filterForm1.value);
    // Here we have call the funtion to retrieve data and change datasource

    const fdate = formatDate(filterForm1.startDate1, 'yyyy-MM-dd', 'en-US', '+0530');
    const ldate = formatDate(filterForm1.endDate1, 'yyyy-MM-dd', 'en-US', '+0530');
    const param = filterForm1.search1;

    console.log("fdate",fdate);
    console.log("ldate",ldate,"param",param);
    this.getAllEntityFilter(param,fdate,ldate);
  }
  
  onSubmitFilter2(filterForm2) {
    console.log(filterForm2.value);
    // Here we have call the funtion to retrieve data and change datasource

    const fdate = formatDate(filterForm2.startDate2, 'yyyy-MM-dd', 'en-US', '+0530');
    const ldate = formatDate(filterForm2.endDate2, 'yyyy-MM-dd', 'en-US', '+0530');
    const param = filterForm2.search2;

    console.log("fdate",fdate);
    console.log("ldate",ldate,"param",param);
    this.getAllEntityFilter(param,fdate,ldate);
  }
  
  

  APIgetEntitySummary() {
    var status={
	Entity_Status:"C"
	}
       console.log("unapproved status",status)
	   this.es.getAllNewEntitySummaryMongo(status)
      .subscribe(r => {
       console.log("summary from mongo",r) 
        this.entity = r;
        this.onChangeDataSource(this.entity);
        if (r.message == "success") {
          this.$modal.successModal({
            title: 'Entity Registration',
            msg: 'Entity has been Approved'
          });
        }
      }); 

  }
  
    APIgetEntityRejection(){
    var status={
	Entity_Status:"R"
	} 
       console.log("unapproved status",status)


		this.es.getAllNewEntitySummaryMongo(status)
      .subscribe(m => {
       console.log("summary from mongo approved entities",m)
         this.entitySummary = m;     
         this.entitySummary = this.entitySummary.filter(function(val,i){
         return val.Entity_EmailID !== "tata@gmail.com";
        });
        this.onChangeDataSource2(this.entitySummary) ;

      }); 
      }
  
  onChangeDataSource(value) {
    this.dataSource = new MatTableDataSource(value);
    //this.dataSource.paginator = this.paginator;
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.t1Sort;
	//this.dataSource.sort = this.t2Sort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }

  APIgetAllEntitySummaries() {
  /*  this.es.getAllEntitySummary("TATA")
      .subscribe(m => {
        this.entitySummary = m;     
        this.onChangeDataSource1(this.entitySummary) ;
      });
 */
// get all aprroved entities from mongo
//this.statusMongo="A";
 //console.log("approved status",this.statusMongo)
var status={
	Entity_Status:"A"
	}
       console.log("unapproved status",status)


 // this.es.getAllNewEntitySummaryMongo(status)
  this.es.newGetEntitySummaryMongoExceptTa(status)
      .subscribe(m => {
		  
         console.log("summary from mongo approved entities i ",m);
		
		m.map((val,i) => {
			
			 //console.log("val.POI _ : ",val.POI); 
		const encryptedValues = ['e0912c26238f29604f5998fa1fbc78f6', '0888e0558c3bce328cd7cda17e045769'];
		
		const key = '18bcd0b950de300fb873788958fde988fec9b478a936a3061575b16f79977d5b';
		const IV = '2e11075e7b38fa20e192bc7089ccf32b';
			 
		 })
         this.entitySummary = m;     
        this.onChangeDataSource1(this.entitySummary) ;
        
    
 
      }); 

  }

  Pan(i,datas){
	  // console.log("datas ",datas);
	 const key = '18bcd0b950de300fb873788958fde988fec9b478a936a3061575b16f79977d5b';
		const IV = '2e11075e7b38fa20e192bc7089ccf32b';
        
		//for(let encrypted of encryptedValues) {
		const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Hex.parse(datas) }, CryptoJS.enc.Hex.parse(key), { 
        iv: CryptoJS.enc.Hex.parse(IV), 
        mode: CryptoJS.mode.CBC
       }); 
	 //console.log("datas ",decrypted.toString(CryptoJS.enc.Utf8));  
	 this.panCard[i]= decrypted.toString(CryptoJS.enc.Utf8);   
	// console.log("decrypted ---- ",this.panCard.i);  
  }
  
onChangeDataSource1(value) {
  this.dataSource1 = new MatTableDataSource(value);
  //this.dataSource1.paginator = this.paginator.toArray()[1]; 
  this.dataSource1.paginator = this.paginator.toArray()[0]; 
  this.dataSource1.sort = this.t2Sort;
  this.noRecord1 = this.dataSource1.connect().pipe(map(data => data.length === 0));
}

onChangeDataSource2(value) {
  this.dataSource2 = new MatTableDataSource(value);
  this.dataSource2.paginator = this.paginator.toArray()[2];  
  this.dataSource2.sort = this.t3Sort;
  this.noRecord2 = this.dataSource2.connect().pipe(map(data => data.length === 0));
} 

  approveEntityComplaints(Entity_Ref_No): void {
    let entityRefNum = Entity_Ref_No.toString();
    let E_Approve_By = this.db.get(Constants.SESSSION_STORAGE, Constants.TATAUSER_NAME);
    var data = {
      "header": {
        "event_const": "CNST_UPDATE_ENTITY_DETAILS",
        "head_id": 123
      },
      "jsonblob":
      {
        "Entity_Status": "A",
        "E_Approve_By": this.Entity_EmailID,
        "E_Approve_Date": currentdat,
		"E_Approve_Time": formatTime,
        "Entity_Ref_No": entityRefNum
      }
    };
   // console.log("Data",data);
    this.entity = this.entity.filter(function(val,i){
     // return val.Key !== Entity_Ref_No;
     return val.Entity_EmailID !== "tata@gmail.com";
    });

    this.onChangeDataSource(this.entity);
    //this.APIgetEntitySummary();
   
    // console.log("after");
    this.es.updateEntitySummaryforApproval(data)
      .subscribe(r => {
       let entityResponse = {
          'Key': Entity_Ref_No,
          'Record':r.updateMongoStatus
        }
        this.entitySummary.push(entityResponse)
        this.onChangeDataSource1(this.entitySummary) ;                
        console.log("r.updateMongoStatus.Entity_Status",r.updateMongoStatus);  
        if (r.updateMongoStatus.Entity_Status == "A") {
          this.$modal.successModal({
            title: 'Confirmation',
            //add ENTITY_ID not ENITY_REF_NO
            msg: 'Entity has been approved '+Entity_Ref_No
          });
//Added for page refresh
          //this.APIgetEntitySummary();
          this.APIgetAllEntitySummaries();
        }
        var data = 
          {
            "EmailId": r.updateMongoStatus.EmailId,
            "Mobno" : r.updateMongoStatus.MobileNumber,
            "notificationDate": currentdat,
            "contact_name": r.updateMongoStatus.EntityName,
            "entity_ref_number":r.updateMongoStatus.Entity_Ref_No,
            "entity_username":r.updateMongoStatus.entity_username,
            "notificationType":"EntityApproval"
            
          }
        
        this.ls.entityRegistrationNotification(data)
        .subscribe(r => {
          this.$modal.successModal({
            title: 'Notification',
            msg: 'Entity has been Approved'
          });
        })
      })
  }

  rejectEntityComplaints(Entity_Ref_No,Entity_EmailID, comment): void {
    let entityRefNum = Entity_Ref_No.toString();
    let E_Approve_By = this.db.get(Constants.SESSSION_STORAGE, Constants.TATAUSER_NAME);
    var data = {
      "header": {
        "event_const": "CNST_UPDATE_ENTITY_DETAILS",
        "head_id": 123
      },
      "jsonblob":
      {
        "Entity_Status": "R",
        "E_Approve_By": this.Entity_EmailID,
        "E_Approve_Date": currentdat,
		"E_Approve_Time": formatTime,
        "Entity_Ref_No": entityRefNum,
        "Entity_EmailID":Entity_EmailID,
        "Entity_Comment":comment
      }
    };
   console.log("data",data);
    this.entity = this.entity.filter(function(val,i){
      return val.Key !== Entity_Ref_No;
    });
    
    this.onChangeDataSource(this.entity);

    this.es.updateEntitySummaryforApproval(data)
      .subscribe(r => {
        //this.entity.push(r);
        let entityResponse = {
          'Key': Entity_Ref_No,
          'Record':r.updateMongoStatus
        }
        //Object.assign(this.entitySummary,entityResponse)
        this.entitySummary.push(entityResponse)
this.onChangeDataSource1(this.entitySummary);
        console.log("Entity_Status ", r.updateMongoStatus.Entity_Status);

        if (r.updateMongoStatus.Entity_Status == "R") {
          this.$modal.errorModal({
            title: 'Entity Registration',
            msg: 'Entity has been Rejected '
          });
		  //this.APIgetEntitySummary();
          this.APIgetAllEntitySummaries();
        }
        var data = 
        {
          "EmailId": r.updateMongoStatus.EmailId,
          "Mobno" : r.updateMongoStatus.MobileNumber,
          "notificationDate": currentdat,
          "contact_name": r.updateMongoStatus.EntityName,
          "entity_ref_number":r.updateMongoStatus.Entity_Ref_No,
          "entity_username":r.updateMongoStatus.entity_username,
          "notificationType":"EntityRejection"
          
        }
      
      this.ls.entityRegistrationNotification(data)
      .subscribe(r => {
        this.$modal.errorModal({
          title: 'Notification',
          msg: 'Entity has been Rejected'
        });
      })

      })
	this.APIgetEntityRejection();
  }

 
  download(file1,entityId,filename){  
  
    var data = {
      "Entity_ID": entityId,
      "FileType": "KYC",
      "FileName": file1
	 // "FileName":this.fileDownload

    } 

  this.es.download(data).subscribe(r => { 

   console.log("response --- : ",r); 
   
  // for(var i=0;i<this.fileDownload.length;i++){
    this.downloadFile(r, file1);
	//this.downloadFile(r, this.fileDownload[i]);
  // }
    this.$modal.successModal({
      title: 'Entity Summary',
      msg: 'File has been downloaded Successfully'
    });   
  })
  this.fileDownload = []; 
}

private downloadFile(res: any, filename: string): void {
  const url = window.URL.createObjectURL(res);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.setAttribute('style', 'display: none');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}


getAllEntityForApprovalFilter(param1,fdate,todate){
  //console.log("inside main getAllEntityForApprovalFilter function ");
 
 // console.log("inside main function "+param1+"$$$"+fdate+"$$$$"+todate);
  this.es.getAllEntityForApprovalFilter(param1,fdate,todate)
  .subscribe(r => {
    this.filterData = r;
    this.onChangeDataSource(this.filterData);
    console.log("12345 :", this.filterData);
  })

}

getAllEntityFilter(param1,fdate,todate){
  //console.log("inside main getAllEntityFilter function ");
 
 // console.log("inside main function "+param1+"$$$"+fdate+"$$$$"+todate);
  this.es.getAllEntityForApprovalFilter(param1,fdate,todate)
  .subscribe(r => {
    this.filterData = r;
    this.onChangeDataSource1(this.filterData);
    console.log("12345 :", this.filterData);
  })

}
//deactivate account method
deactivateEntity(data,entityid,role)
{

  var datajson={
    "Entity_Type":role,
    "Entity_ID":entityid,
    "BlackList_Reason":data.deactvReason,
    "BlackList_Status":data.deactvStatus

  }
  console.log("deactivate ts method",data)
  this.es.deactivateEntitySerive(datajson).subscribe(result =>
  {
    //this.onChangeDataSource(result);
	console.log("result .. ",result);
	if(result.Status === 'Failed')
	{
		this.$modal.errorModal({
            title: 'Entity Blacklist',
           // msg: 'Error happened while Blacklisting an Entity '
		   msg: 'Entity may be already set for given Status'
          });
	}

	else if(result.Status === 'Success'){
		if(result.Message === 'Blacklisting Successful'){
		 this.$modal.successModal({
            title: 'Entity Blacklist',
            msg: 'Entity has been Blacklisted'
          });
		  }
		 else{
			this.$modal.successModal({
            title: 'Entity Blacklist',
            msg: 'Entity has been Activated'
          });
		 }
	}

  })
}

// update the entity role
//updateRole(data,emailid)
//{
//console.log("update entity role",data)
//var roleData={
//  "Entity_Role":data,
//  "Entity_EmailID": emailid,
//}
//this.es.updateRoleSerivce(roleData).subscribe(result =>
  //{
 //  this.APIgetAllEntitySummaries();  })
//}
// for the deactivate dialog
openDialog(getValue,emailid,role): void {
  const dialogRef = this.dialog.open(MyDialogComponent, {
    data: {setValue:getValue,
            setRole : role
    },
  });

  dialogRef.afterClosed().subscribe(result => {
    this.deactvResult = result;
   console.log("on submit the root header in dialog",result)
    if (result !== "undefined" && getValue === 'blacklist') {
     
      this.deactivateEntity(result,emailid,role);
    }
    else if(result !== "undefined" && getValue === 'updaterole')
    {
     // this.updateRole(result,emailid)
    }
   console.log('The dialog was closed', result); 
  });
}
  
  deactivateStatus(result: any) {
    throw new Error("Method not implemented.");
  }
  downloadcsv(Status){ 

   var fileName;
   const currentdat = formatDate(now, 'medium', 'en-US', '+0530');

   this.es.downloadcsv(Status).subscribe(r => {
    if(Status=='C'){
      fileName = currentdat+ ' Pending Entity Records.csv';
   }
   if(Status=='A'){
     fileName = currentdat+ ' Active Entity Records.csv';
  }
  if(Status=='R'){
   fileName = currentdat+ ' Rejected Entity Records.csv';
}
   importedSaveAs(r, fileName)
   //  this.downloadFile(r, Batch_Id);
     this.$modal.successModal({
       title: 'Entity Summary',
       msg: 'File has been downloaded Successfully'
     });   
   })
 
 }

}

export class MyDataSource extends DataSource<any[]> {

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }

}
